import { action, makeObservable, observable } from "mobx";
import { ValidatedValue } from "./validator";
import { NnwBeneficiary, NnwBeneficiaryModel } from "./nnwBeneficiary";
import { AddressClass, AddressModel } from "./address";
import { clientValidators } from "./clientValidators";

export interface NnwClientModel {
  pesel: ValidatedValue<string>;
  firstName: ValidatedValue<string>;
  lastName: ValidatedValue<string>;
  address: AddressModel;
  addressTheSame: boolean;
  heartAttackAndStroke: boolean;
  beneficiaryChecked: boolean;
  beneficiary: NnwBeneficiaryModel;

  validateClientData: () => void;

  clearErrorMessages: () => void;
}

interface NnwClientArguments {
  pesel?: string;
  firstName?: string;
  lastName?: string;
  address?: AddressModel;
  addressTheSame?: boolean;
  heartAttackAndStroke?: boolean;
  beneficiaryChecked?: boolean;
  beneficiary?: NnwBeneficiary;
}

export class NnwClient implements NnwClientModel {
  @observable pesel: ValidatedValue<string> = new ValidatedValue("", [...clientValidators.pesel]);
  @observable firstName: ValidatedValue<string> = new ValidatedValue("", clientValidators.firstName);
  @observable lastName: ValidatedValue<string> = new ValidatedValue("", clientValidators.lastName);
  @observable address: AddressModel = AddressClass.default();
  @observable addressTheSame = true;
  @observable heartAttackAndStroke = false;
  @observable beneficiaryChecked = false;
  @observable beneficiary = new NnwBeneficiary();

  constructor(args?: NnwClientArguments) {
    makeObservable(this);

    this.pesel.value = args?.pesel ?? "";
    this.firstName.value = args?.firstName ?? "";
    this.lastName.value = args?.lastName ?? "";
    this.address = args?.address ?? AddressClass.default();
    this.addressTheSame = args?.addressTheSame ?? true;
    this.heartAttackAndStroke = args?.heartAttackAndStroke ?? false;
    this.beneficiary = args?.beneficiary ?? new NnwBeneficiary();
  }


  @action
  public validateClientData() {
    this.pesel.validate();
    this.firstName.validate();
    this.lastName.validate();
    this.address.validate();
    if (this.beneficiaryChecked) {
      this.beneficiary.validateNnwBeneficiary();
    }
  }

  @action
  public clearErrorMessages() {
    this.pesel.clearValidation();
    this.firstName.clearValidation();
    this.lastName.clearValidation();
  }
}
